import {
  Add,
  CancelOutlined,
  Check,
  DeleteOutline,
  PlayArrow,
} from "@mui/icons-material";
import {
  Box,
  Button,
  darken,
  Divider,
  InputAdornment,
  lighten,
  Paper,
  Popover,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { memo, useState } from "react";
import ColorPicker, { themes } from "react-pick-color";
import { v4 as uuidv4 } from "uuid";
import useStyles from "./styles";

const Escala = memo(
  (
    {
      escala = [],
      setEscala = () => {},
      variant = "traffic",
      setCheckChanges = () => {},
      disableNew = false,
    },
    key
  ) => {
    let theme = useTheme();
    const styles = useStyles(theme);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElColor, setAnchorElColor] = useState(null);
    const [escalaSelected, setEscalaSeletec] = useState(null);
    const [escalaSnapshot, setEscalaSnapshot] = useState(null);
    const [unit, setUnit] = useState(
      variant == "traffic" ? "%" : variant == "power" ? "" : "dBm"
    );

    // useEffect(() => {
    //   if (!escalaSelected) return;
    //   setCheckChanges(true);
    //   setEscala((data) =>
    //     data.map((esc, index) =>
    //       escalaSelected.id != esc.id
    //         ? esc
    //         : {
    //             cor: escalaSelected.cor,
    //             label:
    //               isNaN(Number(escalaSelected.label)) ||
    //               escalaSelected.label === "" ||
    //               escalaSelected.label === null
    //                 ? 0
    //                 : escalaSelected.label,
    //           }
    //     )
    //   );
    //   orderByEscala(variant == "traffic");
    // }, [escalaSelected]);

    const escalaDefaultTrafego = [
      { cor: theme.palette.enlaces.offline.main, label: "Offline" },
      { cor: theme.palette.enlaces.p0.main, label: "0", id: uuidv4() },
      { cor: theme.palette.enlaces.p1.main, label: "1", id: uuidv4() },
      { cor: theme.palette.enlaces.p5.main, label: "5", id: uuidv4() },
      { cor: theme.palette.enlaces.p15.main, label: "15", id: uuidv4() },
      { cor: theme.palette.enlaces.p25.main, label: "25", id: uuidv4() },
      { cor: theme.palette.enlaces.p50.main, label: "50", id: uuidv4() },
      { cor: theme.palette.enlaces.p70.main, label: "70", id: uuidv4() },
      { cor: theme.palette.enlaces.p80.main, label: "80", id: uuidv4() },
      { cor: theme.palette.enlaces.p90.main, label: "90", id: uuidv4() },
    ];
    const escalaDefaultPotencia = [
      {
        cor: theme.palette.enlaces.offline.main,
        label: "Sem Dados",
        id: uuidv4(),
      },
      { cor: theme.palette.enlaces.p70.main, label: "Ruim", id: uuidv4() },
      { cor: theme.palette.enlaces.p0.main, label: "Bom", id: uuidv4() },
      { cor: theme.palette.enlaces.p5.main, label: "Excelente", id: uuidv4() },
    ];
    const escalaDefaultFTTH = [
      {
        cor: theme.palette.enlaces.offline.main,
        label: "Sem Dados",
        id: uuidv4(),
      },
      { cor: theme.palette.enlaces.p5.main, label: "-16", id: uuidv4() },
      { cor: theme.palette.enlaces.p20.main, label: "-23", id: uuidv4() },
      { cor: theme.palette.enlaces.p50.main, label: "-33", id: uuidv4() },
      { cor: theme.palette.enlaces.p90.main, label: "-40", id: uuidv4() },
    ];

    const handleClick = (event, escala, index) => {
      setAnchorEl(event.currentTarget);
      setEscalaSeletec({ ...escala, index });
      setEscalaSnapshot(escala);
    };
    const handleClose = () => {
      setAnchorEl(null);
      setEscalaSeletec(null);
    };

    const remove = () => {
      if (!escalaSelected) return;
      setCheckChanges(true);
      setEscala((data) => data.filter((esc) => esc.id !== escalaSelected.id));
      handleClose();
    };
    const redefinir = () => {
      setCheckChanges(true);
      if (variant == "traffic") setEscala(escalaDefaultTrafego);
      if (variant == "power") setEscala(escalaDefaultPotencia);
      if (variant == "FTTH") setEscala(escalaDefaultFTTH);
    };
    const add = () => {
      setCheckChanges(true);
      setEscala((data) => [
        ...data.slice(0, 1),
        {
          cor: theme.palette.mode == "dark" ? "#474545" : "#c7baba",
          label: "0",
          id: uuidv4(),
        },
        ...data.slice(1),
      ]);
    };
    const clear = () => {
      if (escalaSnapshot) {
        setEscala((data) =>
          data.map((esc, index) =>
            index === escalaSelected.index ? escalaSnapshot : esc
          )
        );
      }
      setAnchorEl(null);
      setEscalaSeletec(null);
    };
    const orderByEscala = (isAscending = true) => {
      setEscala((data) =>
        [...data].sort((a, b) => {
          if (a.label === "Offline" || a.label === "Sem Dados") return -1;
          if (b.label === "Offline" || b.label === "Sem Dados") return 1;

          const comp = parseFloat(a.label) - parseFloat(b.label);
          return isAscending ? comp : -comp;
        })
      );
    };

    return (
      <>
        <Stack sx={styles.barEscala} key={key}>
          {escala.map((cor, index) => (
            <Stack
              key={"barColor" + index}
              direction="row"
              sx={{
                justifyContent: "center",
                height: "25px",
                width: "100%",
              }}
            >
              <Divider orientation="vertical" />
              <Stack gap={0.4} width="100%">
                <Tooltip
                  title={
                    index != 0 && !(variant == "FTTH" && cor.label == "-40")
                      ? "Clique para editar"
                      : "Não editável"
                  }
                >
                  <Button
                    sx={styles.buttonEscala}
                    onClick={(e) =>
                      index != 0 &&
                      !(variant == "FTTH" && cor.label == "-40") &&
                      handleClick(e, cor, index)
                    }
                  >
                    <Box
                      sx={[
                        styles.boxEscala,
                        {
                          backgroundColor: cor.cor,
                          "&:hover": {
                            backgroundColor:
                              theme.palette.mode == "dark"
                                ? lighten(cor.cor, 0.5)
                                : darken(cor.cor, 0.3),
                          },
                        },
                      ]}
                    />
                  </Button>
                </Tooltip>
                <Typography
                  sx={{ fontSize: "11px", ml: "2px", fontWeight: 500 }}
                >
                  {" "}
                  {cor.label + (index != 0 ? unit : "")}
                </Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
        <Stack direction={"row"} gap={1} mt={3}>
          <Button sx={styles.buttonEscalaConfig} onClick={redefinir}>
            Redefinir
          </Button>
          <Tooltip
            title={escala.length >= 10 ? "Número máximo atingido" : null}
          >
            <span>
              <Button
                sx={styles.buttonEscalaConfig}
                onClick={add}
                startIcon={<Add />}
                disabled={escala.length >= 10 || disableNew}
              >
                Nova escala
              </Button>
            </span>
          </Tooltip>
        </Stack>{" "}
        <Popover
          id={Boolean(escalaSelected) ? "simple-popover" : undefined}
          open={Boolean(escalaSelected)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          sx={styles.popoverEscala}
        >
          <PlayArrow sx={styles.iconEscala} />
          <Paper sx={styles.paperEscala}>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Typography sx={styles.titleEscala}>Escala: </Typography>
              <TextField
                sx={[styles.textFieldEscala, styles.textFieldEscalaNumber]}
                value={escalaSelected?.label}
                type={variant == "power" ? "text" : "number"}
                onChange={(e) => {
                  const newLabel = e.target.value;
                  setEscalaSeletec((data) => ({
                    ...data,
                    label: newLabel,
                  }));
                  setCheckChanges(true);
                  setEscala((data) =>
                    data.map((esc) =>
                      escalaSelected.id !== esc.id
                        ? esc
                        : {
                            ...esc,
                            label:
                              variant !== "power"
                                ? isNaN(Number(newLabel)) ||
                                  newLabel === "" ||
                                  newLabel === null
                                  ? 0
                                  : newLabel
                                : newLabel,
                          }
                    )
                  );
                  orderByEscala(variant == "traffic");
                }}
                size="small"
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="start">
                        <Typography sx={styles.textAdorment}>{unit}</Typography>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Stack>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Typography sx={styles.titleEscala}>Cor: </Typography>
              <TextField
                sx={styles.textFieldEscala}
                value={escalaSelected?.cor}
                size="small"
                onChange={(e) => {
                  const newColor = e.target.value;
                  setEscalaSeletec((data) => ({ ...data, cor: newColor }));
                  setCheckChanges(true);
                  setEscala((data) =>
                    data.map((esc) =>
                      escalaSelected.id !== esc.id
                        ? esc
                        : { ...esc, cor: newColor }
                    )
                  );
                }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Button
                          sx={{
                            minWidth: "15px",
                            minHeight: "16px",
                            width: "15px",
                            height: "16px",
                            borderRadius: "4px",
                            backgroundColor: escalaSelected?.cor,
                          }}
                        />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Stack>
            <ColorPicker
              color={escalaSelected?.cor}
              onChange={(color) => {
                setEscalaSeletec((data) => ({ ...data, cor: color.hex }));
                setCheckChanges(true);
                setEscala((data) =>
                  data.map((esc) =>
                    escalaSelected.id !== esc.id
                      ? esc
                      : { ...esc, cor: color.hex }
                  )
                );
              }}
              theme={theme.palette.mode == "dark" ? themes.dark : themes.light}
            />
            <Stack direction={"row"} justifyContent={"center"} width={"100%"}>
              <Button
                onClick={remove}
                sx={styles.buttomDelete}
                startIcon={<DeleteOutline />}
                disabled={disableNew}
              >
                Remover da escala
              </Button>
            </Stack>
            <Stack
              direction={"row"}
              justifyContent={"center"}
              width={"100%"}
              mt={1}
              mb={-1}
            >
              <Button
                onClick={clear}
                sx={styles.buttomEnd}
                startIcon={<CancelOutlined />}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleClose}
                sx={styles.buttonConcluir}
                startIcon={<Check />}
              >
                Concluir
              </Button>
            </Stack>
          </Paper>
        </Popover>
      </>
    );
  },
  (prevProps, nextProps) => {
    return (
      JSON.stringify(prevProps.escala) === JSON.stringify(nextProps.escala)
    );
  }
);

export default Escala;
